// libs
import React, { memo, useCallback, useMemo, useState } from 'react';
import { styled } from '@nykaa/ui-components';

// global components
import ChunkFallback from 'shared/components/ChunkFallback';
import Portal from 'shared/components/Portal';

// context
import LoaderContext from './context';

// constants
import { OVERLAY_ZINDEX } from 'shared/styles/base';

// defs
interface ILoaderProviderProps {
  children: React.ReactNode;
}

const Loader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: ${OVERLAY_ZINDEX + 10};
  background-color: rgba(0, 0, 0, 0.15);
`;

function LoaderProvider({ children }: ILoaderProviderProps) {
  const [showLoaderFlg, setShowLoader] = useState(false);

  const showLoader = useCallback(() => setShowLoader(true), []);
  const hideLoader = useCallback(() => setShowLoader(false), []);

  const values = useMemo(() => ({ showLoader, hideLoader }), [hideLoader, showLoader]);
  return (
    <LoaderContext.Provider value={values}>
      {children}
      {showLoaderFlg && (
        <Portal>
          <Loader>
            <ChunkFallback />
          </Loader>
        </Portal>
      )}
    </LoaderContext.Provider>
  );
}

export default memo(LoaderProvider);
